'use strict';

exports.__esModule = true;

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

exports.create = create;
exports.createWithWaypoints = createWithWaypoints;
exports.all = all;
exports.current = current;
exports.history = history;
exports.live = live;
exports.type = type;
exports.get = get;
exports.id = id;
exports.update = update;
exports.remove = remove;
exports.ratings = ratings;
exports.waypoints = waypoints;
exports.addWaypoint = addWaypoint;
exports.addOrder = addOrder;
exports.addItem = addItem;

var _quCheck = require('../utils/qu-check');

var _http = require('../network/http');

var _http2 = _interopRequireDefault(_http);

var _modelProvider = require('../model-provider');

var _modelProvider2 = _interopRequireDefault(_modelProvider);

var _items = require('./items');

var _items2 = _interopRequireDefault(_items);

var _orders = require('./orders');

var _orders2 = _interopRequireDefault(_orders);

var _waypoints2 = require('./waypoints');

var _waypoints3 = _interopRequireDefault(_waypoints2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var API = {
  CUSTOMER_JOBS: '/customer/jobs',
  CUSTOMER_JOBS_RATING: '/customer/jobs/rating_types'
};

var jobs = {
  create: create,
  createWithWaypoints: createWithWaypoints,
  all: all,
  current: current,
  history: history,
  type: type,
  id: id,
  get: get,
  update: update,
  remove: remove,
  ratings: ratings,
  waypoints: waypoints,
  addWaypoint: addWaypoint,
  addOrder: addOrder,
  addItem: addItem,
  live: live
};

exports.default = jobs;

/**
 * Wrapper for `/customer/jobs` API endpoint
 */

/**
 * Creates a new job
 * @param {Object} job - Job model.
 * @param {string} [job.transportMode] - 'Car', 'Scooter' or 'Bike'
 * @returns {promise} containing the entity object of job
 */

function create() {
  var job = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  _quCheck.checker.warn(_quCheck.Job, [job]);

  return _http2.default.post(API.CUSTOMER_JOBS, job).then(_modelProvider2.default.Job);
}

/**
 * New job with order and 2 waypoints
 * @param {object} job - similar as in create() method
 * @returns {promise} contain job parsed by model
 */
function createWithWaypoints() {
  var job = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return create(job).then(function (_job) {
    return _job.createOrder();
  }).then(function (_job) {
    return _job.createWaypointsPair();
  });
}

/**
 * Get all jobs
 * @param {Object} attrs - Attributes
 * @param {boolean} [attrs.includeEntities] - Inlude nested entities in Job (default 'false')
 * @returns {promise} containing the entity array of jobs
 */
function all() {
  var attrs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { includeEntities: false };
  var includeEntities = attrs.includeEntities,
      others = (0, _objectWithoutProperties3.default)(attrs, ['includeEntities']);

  if (includeEntities) return jobsWithEntitiesWrapper((0, _extends3.default)({}, others));

  return _http2.default.get(API.CUSTOMER_JOBS, (0, _extends3.default)({}, others)).then(function (results) {
    return results.map(_modelProvider2.default.Job);
  });
}

/**
 * Get all current jobs
 * @param {Object} attrs - Attributes
 * @returns {promise} containing the entity array of Jobs
 */
function current() {
  var attrs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  attrs.current = true;

  return all(attrs);
}

/**
 * Get all history jobs
 * @param {Object} attrs - Attributes
 * @returns {promise} containing the entity array of Jobs
 */
function history() {
  var attrs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  attrs.current = false;

  return all(attrs);
}

/**
 * Get all live jobs
 * @param {Object} attrs - Attributes
 * @returns {promise} containing the entity array of Jobs
 */
function live() {
  var attrs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  attrs.current = true;

  return all(attrs).then(function (data) {
    var invalidStates = ['pending', 'cancelled', 'complete'];
    return data.filter(function (job) {
      return invalidStates.indexOf(job.state) === -1;
    });
  });
}

/**
 * Get all filtered jobs
 * @param {Object} attrs - Attributes
 * @param {string} [attrs.state] - current state of the job - 'scheduled', 'pending', 'active', 'cancelled'
 * @param {boolean} [attrs.current] - only show active jobs
 * @param {number} [attrs.page] - for paginated results define page number
 * @returns {promise} containing the entity object of job
 */
function type() {
  var attrs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  // eslint-disable-next-line no-shadow
  var state = attrs.state,
      current = attrs.current,
      page = attrs.page;


  return _http2.default.get(API.CUSTOMER_JOBS, { type: state, current: current, page: page }).then(function (results) {
    return results.map(_modelProvider2.default.Job);
  });
}

/**
 * Get job using order number
 * @param {Object} attrs - Attributes
 * @param {string} [attrs.jobId] - order number associated with the job (default 'false')
 * @returns {promise} containing the entity object of job
 */
function get() {
  var attrs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { includeEntities: false };

  // eslint-disable-next-line no-shadow
  var id = attrs.id,
      orderNumber = attrs.orderNumber,
      includeEntities = attrs.includeEntities,
      others = (0, _objectWithoutProperties3.default)(attrs, ['id', 'orderNumber', 'includeEntities']);

  _quCheck.checker.warn(_quCheck.common.jobId, id);

  if (includeEntities) return jobWithEntitiesWrapper(id || orderNumber, (0, _extends3.default)({}, others));

  return _http2.default.get(API.CUSTOMER_JOBS + '/' + (id || orderNumber), (0, _extends3.default)({}, others)).then(_modelProvider2.default.Job);
}

function id(attrs) {
  return get(attrs);
}

/**
 * Updates job using order number
 * @param {Object} attrs - Attributes
 * @param {string} [attrs.id] - order number associated with the job
 * @param {Object} [attrs.job] - Job model.
 * @param {string} [attrs.job.transportMode] - 'Car', 'Scooter' or 'Bike'
 * @returns {promise} containing the entity object of job
 */
function update() {
  var attrs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  // eslint-disable-next-line no-shadow
  var id = attrs.id,
      orderNumber = attrs.orderNumber,
      job = attrs.job;

  _quCheck.checker.warn(_quCheck.common.jobId, id);

  return _http2.default.put(API.CUSTOMER_JOBS + '/' + (id || orderNumber), job).then(_modelProvider2.default.Job);
}

/**
 * Removes job using order number
 * @param {Object} attrs - Attributes
 * @param {string} [attrs.id] - order number associated with the job
 * @returns {promise} containing the entity object of job
 */
function remove() {
  var attrs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  // eslint-disable-next-line no-shadow
  var id = attrs.id,
      orderNumber = attrs.orderNumber;

  _quCheck.checker.warn(_quCheck.common.jobId, id);

  return _http2.default.put(API.CUSTOMER_JOBS + '/' + (id || orderNumber), {
    stateAction: 'cancel'
  }).then(_modelProvider2.default.Job);
}

/**
 * Gets jobs that require ratings
 * @returns {promise} containing the entity array of Jobs
 */
function ratings() {
  return _http2.default.get(API.CUSTOMER_JOBS_RATING).then(function (results) {
    return results.map(_modelProvider2.default.Job);
  });
}

function waypoints() {
  var attrs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  // eslint-disable-next-line no-console
  console.warn('Method waypoints is deprecated. Use waypoints.getAll instead.');
  _waypoints3.default.getAll(attrs);
}

function addWaypoint() {
  var attrs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  // eslint-disable-next-line no-console
  console.warn('Method addWaypoint is deprecated. Use waypoints.create instead.');
  _waypoints3.default.create(attrs);
}

function addOrder() {
  var attrs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  // eslint-disable-next-line no-console
  console.warn('Method addOrder is deprecated. Use orders.create instead.');
  _orders2.default.create(attrs);
}

function addItem() {
  var attrs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  // eslint-disable-next-line no-console
  console.warn('Method addItem is deprecated. Use items.create instead.');
  _items2.default.create(attrs);
}

/**
 * @access private
 * @param {Object} params - params used in GET request
 * @returns {array} containing an Job objects with nested entities
 */
function jobsWithEntitiesWrapper() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return _http2.default.get(API.CUSTOMER_JOBS, params).then(function (_jobs) {
    return _promise2.default.all(_jobs.map(function (job) {
      return waypointsInJobWrapper(job);
    })).then(function (__jobs) {
      return __jobs;
    });
  });
}

/**
 * @access private
 * @param {string} id - jobs order number
 * @param {Object} params - params used in GET request
 * @returns {object} Job - containing an Job object
 */
function jobWithEntitiesWrapper(jobId) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return _http2.default.get(API.CUSTOMER_JOBS + '/' + jobId, params).then(function (job) {
    return waypointsInJobWrapper(job);
  });
}

/**
 * @access private
 * @param {Object} Job - Job model
 * @returns {array} containing an Job objects with nested waypoints
 */
function waypointsInJobWrapper() {
  var job = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  // eslint-disable-next-line
  var id = job.id,
      orderNumber = job.orderNumber;


  return _waypoints3.default.getAll({ jobId: id }).then(function (waypointsObj) {
    job.waypoints = waypointsObj;

    return _modelProvider2.default.Job(job);
  });
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@quiqupltd/quiqupjs/lib/customer/jobs.js
// module id = 1089
// module chunks = 0